import { All, HTTPMethod } from '../../types/enums';
import BaseAdapter from './baseAdapter';
import { AdapterInterface } from '../../types/global';
import { DemographicBreakdownRequest, DemographicBreakdownSegment } from '../../types/debt.type';
import { DebtInsightPieDataRequest, DebtInsightPieDataResponse, DebtType } from '../../api-models';

export default class PostDemographicBreakdown extends BaseAdapter<DebtInsightPieDataResponse[]> implements AdapterInterface {
  rawResponse: DebtInsightPieDataResponse[];

  modifiedRequest: DebtInsightPieDataRequest;

  async adaptResponse(request: DemographicBreakdownRequest): Promise<DemographicBreakdownSegment[]> {
    const formattedRequest = this.adaptRequest(request);
    await this.fetchApiResponse('/api/debt/pie-chart-data', HTTPMethod.Post, formattedRequest);
    return this.rawResponse.map((demographicDatum) => ({
      displayName: demographicDatum.display_name,
      count: demographicDatum.count,
      percentage: demographicDatum.percentage,
      averageDebt: demographicDatum.average_debt,
    }));
  }

  adaptRequest(request: DemographicBreakdownRequest): DebtInsightPieDataRequest {
    this.modifiedRequest = {
      snapshot: request.snapshot,
      branch: 'master',
      lift_data_id: request.localAuthority === All.value || request.localAuthority === '' ? null : Number(request.localAuthority),
      ward_with_other: request.wardWithOther === All.value || request.wardWithOther === '' ? null : request.wardWithOther,
      debt_characteristic_filter_name: request.debtCharacteristicFilterName,
      // replace hyphens with underscores to match expected format in backend - this won't be necessary in future as we'll get exact debt name from the backend response.
      debt_type: request.debtType.replace(/[-]/g, '_') as DebtType,
    };
    return this.modifiedRequest;
  }
}
